export function hasPermission(mbCode){
    let menuButtenList= JSON.parse(window.sessionStorage.getItem("menuButtenList")) || []
    let result = {}
    if(menuButtenList.length>0){
       result =  menuButtenList.find(item => {
            return mbCode == item.mbCode
        });
    }
    return result.permType==1?true:false
}
